/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { useEffect, useState, KeyboardEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import axios from 'axios'
import { getSalesPeople } from '../../services/SalesPeople/getSalesPeople'

export const useSalesPeople = () => {
  const navigate = useNavigate()
  const goToPage = (id: number) => {
    navigate(`/vendedores/${id}`)
  }

  const [searchValue, setSearchValue] = useState('')
  const [isShowFilter, setIsShowFilter] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [salesPeople, setSalesPeople] = useState<GetProductsType>(
    {} as GetProductsType
  )
  const [isLoading, setIsLoading] = useState(true)

  const [statusChecked, setStatusChecked] = useState<string[]>([])
  const [statusCheckedTodos, setStatusCheckedTodos] = useState<string[]>([])
  const [statusCheckedFiltro, setStatusCheckedFiltro] = useState<string[]>([])

  const handleCheckboxChange = (option: string) => {
    if (option === 'TODOS') {
      if (statusChecked.includes('TODOS')) {
        setStatusChecked([])
      } else {
        setStatusChecked([])
        setStatusCheckedTodos([])

        localStorage.setItem('filtroStatus', JSON.stringify([]))
      }
    } else if (statusChecked.includes('TODOS')) {
      setStatusChecked([option])
    } else if (statusChecked.includes(option)) {
      setStatusChecked(statusChecked.filter(item => item !== option))

      statusChecked.length === 1
        ? setStatusCheckedTodos([])
        : setStatusCheckedTodos(['TODOS'])

      localStorage.setItem(
        'filtroStatus',
        JSON.stringify(statusChecked.filter(item => item !== option))
      )
    } else {
      setStatusChecked([...statusChecked, option])
      setStatusCheckedTodos(['TODOS'])
      localStorage.setItem(
        'filtroStatus',
        JSON.stringify([...statusChecked, option])
      )
    }
  }

  const fetchSalesPeople = async (cancel?: any) => {
    setIsLoading(true)
    const result = await getSalesPeople(
      cancel,
      searchValue,
      statusCheckedFiltro,
      currentPage
    )
    setIsLoading(false)
    if ('message' in result) {
      if (result.message === 'cancelToken') {
        ;('')
      } else {
        toast.error(result.message)
      }
    } else {
      setSalesPeople(result)
    }
  }
  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      const source = axios.CancelToken.source()
      fetchSalesPeople(source)
      return () => {
        source.cancel('cancelToken')
      }
    }
  }

  useEffect(() => {
    const source = axios.CancelToken.source()
    fetchSalesPeople(source)
    return () => {
      source.cancel('cancelToken')
    }
  }, [currentPage, statusCheckedFiltro])

  const showFilter = () => setIsShowFilter(!isShowFilter)

  return {
    searchValue,
    setSearchValue,
    isShowFilter,
    currentPage,
    setCurrentPage,
    salesPeople,
    fetchSalesPeople,
    isLoading,
    handleKeyDown,
    goToPage,
    showFilter,

    statusChecked,
    statusCheckedTodos,
    setStatusCheckedFiltro,

    handleCheckboxChange,
  }
}
